import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Loader } from '@mantine/core';
import { getConnectedUserRole } from '../utils';
import { GTM_ROLES } from '../hooks/useUserPermissions';
import { useCurrentUserProfile } from '../hooks/useCurrentUserProfile';
import { useCurrentUser } from "../hooks/useCurrentUser";

interface ExploreProtectedRouteProps {
  children: ReactNode;
}

const getFallbackPath = (userRole: string): string =>
  GTM_ROLES.includes(userRole) ? '/customer360' : '/ideas/all';

export const ExploreProtectedRoute = ({ children }: ExploreProtectedRouteProps) => {
  const currentUser = useCurrentUser();
  const userRole = getConnectedUserRole(currentUser);
  const { canSeeExplore, isExploreAccessResolved } = useCurrentUserProfile();

  if (!isExploreAccessResolved) {
    return (
      <Box p="xl" ta="center">
        <Loader size="sm" />
      </Box>
    );
  }

  if (!canSeeExplore) {
    return <Navigate to={getFallbackPath(userRole)} replace />;
  }

  return <>{children}</>;
};
